import { useMutation } from '@tanstack/react-query';
import type { AxiosRequestConfig } from 'axios';
import { ApiLogger } from 'fmc-digital-common';
import { v4 } from 'uuid';

const useUpdateTCPAConsent = () => {
    const correlationId = v4().toString();
    return useMutation({
        mutationFn: async ({ tcpa, mobile, tcpaRequest: { authToken, xApiKey, url }, logApiEventHandler }: any) => {
            const requestBody = {
                tcpa: tcpa,
                mobile: mobile,
                deviceProfile: {
                    deviceId: '',
                    osType: 'web',
                    osVersion: '',
                    deviceType: '',
                    deviceModel: '',
                    appVersion: ''
                }
            };
            const config: AxiosRequestConfig = {
                method: 'post',
                url: `${url}selfserv/customers/tcpa`,
                headers: {
                    Authorization: `Bearer ${authToken}`,
                    'x-correlation-id': correlationId,
                    'x-api-key': `${xApiKey}`
                },
                data: requestBody
            };
            return ApiLogger(config, logApiEventHandler);
        }
    });
};

export { useUpdateTCPAConsent };
